module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAANdJREFUOBFjYBgMoKi85j8Ig9zCRC0HjVSDSirqGkCYmHDEGUYgA/79/1cPxDXl5bW6hAzDahDMEKDmv4yMTLGdnc2XSTYI3ZDejqblhAwByaO4CNkQJmbGGGINARnECCJAAMkQiAAJZF9nCyOKi0jQi6EU7iKQDJKr/oK81tPWvAJDBw4BZmTxY0cOHrC2dWD8z/Df8f9/hkArW4fbx48cvIKsBhcbxSCQImTDGBj+BxBrGIZB2Ayzs7Fff/TooVe4XAMSx2oQsmGMjIyHujubV+EzBCQHAKc0ah+VIDGLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/subdirectory-arrow-left@3x.png
// module id = FGq7
// module chunks = 6